module.exports = __webpack_public_path__ + "img/AgroDatari_LOGO_25_colorT.69ed2ffb.png";